export enum ProgramType {
  Basic,
  Plus,
  Internal
}

